import { useEffect, useState } from 'react';

export const useFilterClients = (clientsAll) => {
  const [company, setCompany] = useState('all');
  const [clients, setClients] = useState(clientsAll || []);

  const filterByCompany = (companyId) => setCompany(companyId);

  useEffect(() => {
    if (company === 'all') {
      setClients(clientsAll || []);
    } else {
      setClients(
        (clientsAll || []).filter((client) => {
          const companies = (client?.attributes?.companies?.data || []).map(({ id }) => id);
          return companies.includes(company);
        })
      );
    }
  }, [company]);

  return {
    company,
    clients,
    filterByCompany,
  };
};
